'use client'
import React, { createContext, useContext, useState } from 'react'

// NOTA (refactor online/Tauri, 2026-07): el auto-updater de Electron
// (electron-updater) quedó DEFERIDO — ver docs/ARQUITECTURA-ONLINE.md §0.5.
// El shell Tauri carga la web ONLINE, así que "actualizar la app" ya no
// requiere descargar/instalar un binario: basta con recargar la página.
// Este context se deja montado (algunos componentes todavía lo consumen)
// pero inerte: nunca dispara chequeos ni escucha eventos de update — solo
// expone un estado quieto y funciones no-op seguras para no romper el render.
const UpdateContext = createContext(null)

export const UpdateProvider = ({ children }) => {
    const [phase] = useState(null) // siempre null: no hay ciclo de update que correr
    const [version] = useState('')
    const [progress] = useState(0)
    const [dismissed, setDismissed] = useState(false)

    // No-ops: sin proceso nativo de auto-update, no hay nada que chequear/descargar/instalar.
    const checkForUpdate = async () => {}
    const download = () => {}
    const install = () => {}

    return (
        <UpdateContext.Provider value={{
            phase, version, progress, dismissed,
            setPhase: () => {}, setDismissed,
            checkForUpdate, download, install
        }}>
            {children}
        </UpdateContext.Provider>
    )
}

export const useUpdate = () => useContext(UpdateContext)
